<div class="lesson-navigation"></div>

<div class="lesson-container">
	<lb-lesson-card-v2
		[lesson]="lesson()"
		[lessonNumber]="lessonNumber()"
		userView="learner"
		displayedUser="instructor"
		[clickable]="false"
		[showActions]="false"
	></lb-lesson-card-v2>

	@if (!state.showDetails()) {
		<lb-lesson-detail-unavailable userView="learner" />
	} @else {
		@if (canJoin() || canReschedule()) {
			<div class="actions">
				<span class="spacer"></span>
				@if (canJoin()) {
					<a href="https://teams.microsoft.com/?web=1" target="_blank" md-button-brand data-analytics="lesson-join" (click)="onJoinLesson()">Join</a>
				}
				@if (canReschedule()) {
					<button md-button data-analytics="lesson-reschedule" (click)="reschedule()">Reschedule</button>
				}
			</div>
		}

		<div class="lesson-content" [class.lesson-content--full]="!sideContentVisible()">
			@if (sideContentVisible()) {
				<div class="content-side">
					<!-- Surveys are not gated on lessonWorkVisible: they open on their own
					     availableDaysBefore window and are meant to be answerable before the lesson.
					     The external feedback link renders the block on the final lesson even when the
					     grading template defines no surveys of its own. -->
					@if (state.hasSurvey() || state.externalFeedbackSurveyUrl()) {
						<lb-lesson-detail-survey />
					}

					<!-- The instructor's write-up stays theirs until the lesson is actually taught — a
					     pre-lesson draft must not read to the learner as their finished grades. -->
					@if (lessonWorkVisible()) {
						@if (isFinalSemester()) {
							<lb-lesson-detail-project-final />
						}

						@if (isGradedInstructional() && !isFinalSemester()) {
							<lb-lesson-detail-daily-grades />
							<lb-lesson-detail-objectives />
							<lb-lesson-detail-project-progress />
							<lb-lesson-detail-homework />
						}
					}
				</div>
			}

			<div class="content-side">
				@if (lessonWorkVisible()) {
					<lb-lesson-detail-summary />
				} @else {
					<lb-lesson-detail-unavailable userView="learner" [reason]="detailsUnavailableReason()" />
				}
			</div>
		</div>
	}
</div>
